import { render, staticRenderFns } from "./IconSvgPlayerForward.vue?vue&type=template&id=08272b64&scoped=true&"
import script from "./IconSvgPlayerForward.vue?vue&type=script&lang=js&"
export * from "./IconSvgPlayerForward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08272b64",
  null
  
)

export default component.exports